import { Observable } from 'rxjs';
import { QUALIFICATION_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { IQualificationBasisDef } from './iqualification-basis-def';

export interface IQualificationDef {
    availableBases: (category: string, dateOfBirth: Date, orientation?: string) => IQualificationBasisDef[];
    code: string;
    name: string;
    next: INextStepDef;
}

export interface INextStepDef {
    data: (param: string) => Observable<IStepDataDef[]>;
    label: string;
    name: string;
    next: INextStepDef;
}

export interface IStepDataDef {
    code: string;
    name: string;
    categories?: IStepCategoryDef[];
    courses?: IStepCourseDef[];
}

export interface IStepCategoryDef {
  code: string;
  name: string;
  scope: string;
}

export interface IStepCourseDef {
  code: string;
  name: string;
  scope: string;
}

export const NEXT_STEP_DEF_NAMES = {
    LANGUAGE: QUALIFICATION_NAMES.LANGUAGE_CODE_OPTIONAL.slice(0, -4),
    ORIENTATION: QUALIFICATION_NAMES.ORIENTATION_CODE_OPTIONAL.slice(0, -4),
    STUDY_PATH: QUALIFICATION_NAMES.STUDYPATH_CODE_OPTIONAL.slice(0, -4),
    SUBJECT: QUALIFICATION_NAMES.SUBJECT_CODE_OPTIONAL.slice(0, -4),
    TYPE_OF_SCHOOLING: QUALIFICATION_NAMES.TYPE_OF_SCHOOLING_CODE_OPTIONAL.slice(0, -4),
};
